<template>
  <f7-page
    :page-content="true"
  >
    <f7-navbar
      class="bg-madai"
    >
      <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      <f7-nav-title class="text-white">Detalles del perfil</f7-nav-title>
    </f7-navbar>

    <f7-list no-hairlines-md>
      <f7-list-input
        class="required"
        label="Nombre completo"
        type="text"
        placeholder="Escribe tu nombre completo"
        :value="storage.usuario.name"
        @input="storage.usuario.name = $event.target.value"
      ></f7-list-input>
      <f7-list-input
        class="required"
        label="Contraseña"
        type="password"
        placeholder="Escribe una contraseña segura"
        :value="storage.usuario.password"
        @input="storage.usuario.password = $event.target.value"
      ></f7-list-input>
      <f7-list-input
        class="required"
        label="Correo"
        type="email"
        placeholder="Escribe un correo válido"
        :value="storage.usuario.email"
        @input="storage.usuario.email = $event.target.value"
      ></f7-list-input>
      <f7-list-item>
        <f7-button class="margin-auto" @click="actualizarPerfil()" fill>
          Guardar
        </f7-button>
      </f7-list-item>
    </f7-list>
    <navbar-bottom />
  </f7-page>
</template>

<script>
import navbarBottom from '@/components/navbar-bottom'

export default {
  data () {
    return {
      nombre: '',
      correo: '',
      clave: ''
    }
  },
  components: {
    navbarBottom
  },
  methods: {
    async actualizarPerfil () {
      try {
        await this.$api.usuario.guardar(this.storage.usuario)
        this.$f7.dialog.alert('Información actualizada.', `MADAI`, () => {})
      } catch (err) {
        this.$f7.dialog.alert('No se pudo actualizar la información.', `MADAI`, () => {})
      }
    }
  }
}
</script>
